import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SITE } from "../data/site";
import { STATES, stateSlug } from "../data/states";

const popular = ["TX", "CA", "FL", "NY", "GA", "IL", "NJ", "WA"];

export const Footer = () => (
  <footer className="bg-slate-950 text-slate-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="space-y-4">
          <Link to="/" aria-label="ABSLpay home"><Logo light /></Link>
          <p className="text-sm leading-relaxed text-slate-400">
            {SITE.tagline}. A service of {SITE.legalName}, part of the ABSL family of businesses.
          </p>
          <p className="text-sm text-slate-400">
            {SITE.city}, {SITE.region}
            <br />
            <a href={`tel:${SITE.phone}`} className="hover:text-white transition-colors">{SITE.phoneDisplay}</a>
            <br />
            <a href={`mailto:${SITE.email}`} className="hover:text-white transition-colors">{SITE.email}</a>
          </p>
        </div>
        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.15em] text-emerald-400 mb-5">Payroll</h2>
          <ul className="space-y-3 text-sm">
            <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
            <li><Link to="/pricing#compare" className="hover:text-white transition-colors">Compare with Gusto and ADP</Link></li>
            <li><Link to="/#switch" className="hover:text-white transition-colors">Switch providers</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Get a quote</Link></li>
            <li><Link to="/faq" className="hover:text-white transition-colors">FAQ help center</Link></li>
            <li><Link to="/blog" className="hover:text-white transition-colors">Resources</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About us</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.15em] text-emerald-400 mb-5">Popular states</h2>
          <ul className="space-y-3 text-sm">
            {popular.map((a) => (
              <li key={a}>
                <Link to={`/payroll-services/${stateSlug(a)}`} className="hover:text-white transition-colors">
                  {STATES[a][0]} payroll
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.15em] text-emerald-400 mb-5">Coverage</h2>
          <ul className="space-y-3 text-sm">
            <li><Link to="/payroll-services" className="hover:text-white transition-colors">All 50 states and DC</Link></li>
            <li><Link to="/payroll-services#no-income-tax" className="hover:text-white transition-colors">States without wage tax</Link></li>
          </ul>
        </div>
      </div>
      <p className="mt-14 pt-8 border-t border-slate-800 text-xs leading-relaxed text-slate-500">
        &copy; {new Date().getFullYear()} {SITE.legalName}. Gusto, ADP, Paychex and QuickBooks are trademarks of their
        respective owners and are mentioned for comparison only; competitor prices are as published and were checked in{" "}
        {SITE.competitorChecked}. Tax rules change often; information on this site is general and is not tax advice for
        your situation.
      </p>
    </div>
  </footer>
);
